type TargetName = "document" | "window";

const documentListeners: { [event: string]: ((event?: Event) => void)[] } = {};
const windowListeners: { [event: string]: ((event?: Event) => void)[] } = {};

const getListenersAndTargetForName = (targetName: TargetName) => {
  switch (targetName) {
    case "document":
      return {
        listeners: documentListeners,
        target: document,
      };
    case "window":
      return {
        listeners: windowListeners,
        target: window,
      };
    default:
      throw new Error(`Unknown target name '${targetName}'`);
  }
};
const addEventHandler = (targetName: TargetName, event: string, handler: (event?: Event) => void): void => {
  const { listeners, target } = getListenersAndTargetForName(targetName);

  const handlers = listeners[event] || [];
  handlers.push(handler);
  listeners[event] = handlers;

  target.addEventListener(event, handler);
};

const removeEventHandler = (targetName: TargetName, event: string, handler: (event?: Event) => void): void => {
  const { listeners, target } = getListenersAndTargetForName(targetName);

  let handlers = listeners[event] || [];
  const handlerIndex = handlers.findIndex((listener) => listener === handler);
  if (handlerIndex > -1) {
    handlers = handlers.splice(handlerIndex, 1);
    listeners[event] = handlers;
  }
  target.removeEventListener(event, handler);
};

const removeAllEventHandlers = (): void => {
  Object.keys(documentListeners).forEach((event) =>
    documentListeners[event].forEach((listener) => document.removeEventListener(event, listener)),
  );

  Object.keys(windowListeners).forEach((event) =>
    windowListeners[event].forEach((listener) => window.removeEventListener(event, listener)),
  );
};

export const ListenerHelper = {
  addEventListener: addEventHandler,
  removeEventListener: removeEventHandler,
  removeAllEventListeners: removeAllEventHandlers,
};
